<template>
  <div id="app">
    <router-view/>
  </div>
</template>

<script>
// import { user } from './user.js';

export default {
  name: 'App',
  components: {
    // appHeader: Header
  },
  mounted() {}
};
</script>

<style>
#app {
  font-family: 'Rubik', sans-serif;
  font-weight: 300;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
  color: #18385f;
}
</style>
